// extracted by mini-css-extract-plugin
module.exports = {"content":"DeviationType_content__3qPka","submitBtn":"DeviationType_submitBtn__3CL0P"};